import {publish} from '@/script/event.mjs'

export const pushSavePublish = () => () => {
    return async function () {
        await this.execute(
            () => this.runAction(
                async () => {
                    const {
                        canPushProduct,
                        publishProduct,
                        pushProduct,
                        saveMap,
                    } = this.actions

                    if (canPushProduct(this.root)) {
                        const results = await pushProduct([this.root])

                        const rejected = results.find(
                            e => 'rejected' === e.status
                        )

                        if (rejected) {
                            throw rejected.reason
                        }
                    }

                    await saveMap()
                    publish(this, 'save')
                    await publishProduct([this.root])
                },

                {action: '更新&发布制品'}
            )
        )
    }
}
